import * as React from "react";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Masonry from "@mui/lab/Masonry";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import ButtonControlPanel from "./ButtonControlPanel2";

function calcHeights(textArr) {
  var heights = [];
  for (let i = 0; i < textArr.length; i++) {
    heights?.push(textArr[i].paragraph?.length / 2);
  }
  return heights;
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  color: theme.palette.text.secondary
}));

export default function MasonryWithVariableHeightItems({ textArr }) {
  const [locations, setLocations] = React.useState([]);
  let heights = calcHeights(textArr);
  console.log("i am textarr in masonry", textArr);
  React.useEffect(() => {
    const initialLocations = textArr.map((text, index) => {
      if (text.paragraph) {
        const element = document.getElementById(`paragraph-${index}`);
        const rect = element.getBoundingClientRect();
        return {
          keyword: text.keywords,
          paragraph: text.paragraph,
          x: rect.x,
          y: rect.y
        };
      }
      return null;
    });

    setLocations(initialLocations.filter((location) => location !== null));
  }, [textArr]);
  const handleDrag = (keyword, paragraph, x, y) => {
    // Find the index of the paragraph in the locations array
    const index = locations.findIndex((item) => item.paragraph === paragraph);
    // console.log(paragraph, x, y);
    if (index !== -1) {
      // Update the existing location in the locations array
      const updatedLocations = [...locations];
      updatedLocations.splice(index, 1); // Remove the item at the current index
      updatedLocations.splice(index, 0, {
        keyword: keyword,
        paragraph: paragraph,
        x: x,
        y: y
      }); // Insert the updated item at the current index
      setLocations(updatedLocations);
    } else {
      // Add a new location to the locations array
      const newLocation = { paragraph, x, y };
      setLocations((prevLocations) => [...prevLocations, newLocation]);
    }
    console.log("locations", locations);
  };

  return (
    <div>
      <Box sx={{ minWidth: 500, minHeight: 377, mx: "auto", my: "auto" }}>
        <Masonry columns={3} spacing={2}>
          {textArr.map((text, index) => {
            if (text.paragraph) {
              const height = text.paragraph.length / 2;
              return (
                <div key={index} style={{ position: "relative" }}>
                  <Draggable
                    onDrag={(event, { x, y }) =>
                      handleDrag(text.keywords, text.paragraph, x, y)
                    }
                  >
                    <Paper>
                      <StyledAccordion sx={{ minHeight: height }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography>
                            Paragraph {index + 1}: {textArr[index].keywords}{" "}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div id={`paragraph-${index}`}>{text.paragraph}</div>
                        </AccordionDetails>
                      </StyledAccordion>
                    </Paper>
                  </Draggable>
                  <div
                    style={{ position: "absolute", right: 1, bottom: 1 }}
                  ></div>
                </div>
              );
            }
            return null;
          })}
        </Masonry>
      </Box>
      <div className="flex justify-end">
        <ButtonControlPanel texts={locations} />
      </div>
    </div>
  );
}
